/** Base pathname for recruitment applicant APIs (use for MSW regex builders). */
export const APPLICANT_BASE_PATH = '/rec/applicant';

export const APPLICANT_ENDPOINTS = {
  search: `${APPLICANT_BASE_PATH}/search`,
  byId: (applicantId: string | number) => `${APPLICANT_BASE_PATH}/search/${applicantId}`,
  feedback: (applicantId: string | number) =>
    `${APPLICANT_BASE_PATH}/search/${applicantId}/feedback`,
  generateCVComparisonFeedback: (applicantId: string | number) =>
    `${APPLICANT_BASE_PATH}/search/${applicantId}/generateCVComparisonFeedback`,
  jiraComments: (applicantId: string) =>
    `${APPLICANT_BASE_PATH}/search/${applicantId}/jira-comments`,
  jiraAttachment: (issueId: string, filename: string) =>
    `${APPLICANT_BASE_PATH}/jiraAttachments?issueId=${encodeURIComponent(issueId)}&filename=${encodeURIComponent(filename)}`,
  basic: (id: string | number) => `${APPLICANT_BASE_PATH}/search/${id}/basic`,
  history: (id: string | number, orderBy: string, orderDirection: string) =>
    `${APPLICANT_BASE_PATH}/search/${id}/history?orderBy=${orderBy}&orderDirection=${orderDirection}`,
  interviews: (id: string | number) => `${APPLICANT_BASE_PATH}/search/${id}/interviews`,
  updateVacancyCode: `${APPLICANT_BASE_PATH}/updateVacancyCode`,
  updateCountry: (applicantId: string | number) =>
    `${APPLICANT_BASE_PATH}/update/${applicantId}/country`,
  updateProfile: (applicantId: string) =>
    `${APPLICANT_BASE_PATH}/update/${applicantId}/profile`,
  updateHistory: (id: string | number) => `${APPLICANT_BASE_PATH}/update/${id}/history`,
  updateAdditional: (id: string | number) =>
    `${APPLICANT_BASE_PATH}/update/${id}/additional`,
  add: `${APPLICANT_BASE_PATH}/add`,
  /** Questions allocated to the applicant for one vacancy stage. */
  questionAnswers: (id: string | number, vacancyStageId: number) =>
    `${APPLICANT_BASE_PATH}/questionAnswers/${id}?vacancyStageId=${vacancyStageId}`,
  /** Stages (GENERAL + INTERVIEW) the applicant has reached, with questions and the manual action. */
  applicantStages: (id: string | number) => `${APPLICANT_BASE_PATH}/applicants/${id}/stages`,
  /** Manual "Allocate & Trigger" for one vacancy stage (same function as the automatic Jira trigger). */
  triggerStage: (id: string | number, vacancyStageId: number) =>
    `${APPLICANT_BASE_PATH}/applicants/${id}/stages/${vacancyStageId}/trigger`,
  applicantAnswers: (id: string | number) =>
    `${APPLICANT_BASE_PATH}/applicantAnswers/${id}`,
  messages: (id: string | number) =>
    `${APPLICANT_BASE_PATH}/getMessages/${id}/messages`,
  /** Mock welcome send until the WhatsApp welcome API is available. */
  sendWelcome: `${APPLICANT_BASE_PATH}/messages/send-welcome`,
  companyTech: (id: string | number, companyId: string | number) =>
    `${APPLICANT_BASE_PATH}/search/${id}/company/${companyId}`,
  testSend: `${APPLICANT_BASE_PATH}/messages/test-send`,
  resendQuestion: (questionAnswerId: number) =>
    `${APPLICANT_BASE_PATH}/questions/${questionAnswerId}/resend`,
  manualWelcome: `${APPLICANT_BASE_PATH}/manual-welcome`,

  // Process Status - history popup only (grid data comes from /search)
  processHistory: (id: number) => `${APPLICANT_BASE_PATH}/process-history/${id}`,
} as const;
